// extracted by mini-css-extract-plugin
export default {"root":"SiderContainer_root__uyYcl","header":"SiderContainer_header__CmGxh","closeIcon":"SiderContainer_closeIcon__KRNqR"};